module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921122334_T.b550f4ea.jpg";